import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
  apiKey: '73e29701df022aeef6295f45dca7f771',
  plugins: [new BugsnagPluginVue()],
  appVersion: process.env.VERSION,
  releaseStage: process.env.RELEASE,
  notifyReleaseStages: ['production'],
});

Bugsnag.getPlugin('vue')
  .installVueErrorHandler(Vue);
